import { DialogContent, DialogActions } from '@mui/material';
import { ThemeButton } from '@shared/ui/buttons';
import Note from '@shared/ui/messages/Note';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useForm, Controller, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormGroup } from '@shared/ui/forms/display';
import { Checkbox } from 'rsuite';
import { CounterTag } from '@shared/ui/parts';
import { getTotalActiveHoldCards } from '@utils/helpers';
import { useGroups } from '@app/api/groups/useGroups';

export default function DeleteTeamDialog({
  close,
  data,
  setTitle,
  setTitleIcon,
  setClassNames,
  setHideCloseButton,
  setImage,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const { deleteGroup } = useGroups();
  const { t } = useTranslation();
  const [isConfirm, setIsConfirm] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
  });

  const termsAcceptWatch = useWatch({
    control,
    name: 'terms_accept',
  });

  const { count_total } = useSelector((state) => state.my_team);
  const isDeletionError = count_total === 1 || data.users?.length > 0;

  async function onSubmit() {
    setIsLoading(true);
    try {
      await deleteGroup({ id: data.id });
      close();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (isDeletionError) {
      setTitle('deletion_error');
      setTitleIcon('error');
      setClassNames('');
      setHideCloseButton(false);
      setImage('');
    } else if (isConfirm) {
      setClassNames('');
      setImage('');
      setTitleIcon('warning');
    } else {
      setClassNames('top-img-style');
      setImage('delete');
      setTitleIcon('');
    }
  }, [isDeletionError, isConfirm]);

  console.log(data);

  return (
    <>
      <DialogContent>
        <div className="form">
          {!isDeletionError && <p>{t('are_sure_delete_team')}</p>}
          <CounterTag
            data={{
              ...data,
              cardsCount: {
                active: data.cardsCount?.active,
                hold: data.cardsCount?.hold,
              },
            }}
            iconType={!isDeletionError ? 'cards' : 'members'}
          />
        </div>
        {!isDeletionError && !isConfirm && (
          <Note
            marginTop
            type="error"
            title={t('action_is_irreversible')}
            content={t('delete_team_action_note')}
          >
            {/* todo: поменять на active hold карты, убрать blocked из подсчета */}
            {getTotalActiveHoldCards(data) > 0 && (
              <FormGroup error={errors?.terms_accept}>
                <Controller
                  control={control}
                  name="terms_accept"
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Checkbox
                      onChange={(val, checked) => field.onChange(checked)}
                      checked={field.value}
                    >
                      {t('i_agree_to_delete_team')}
                    </Checkbox>
                  )}
                />
              </FormGroup>
            )}
          </Note>
        )}
        {isDeletionError && (
          <Note
            html
            marginTop
            type="error"
            title={t('unable_delete_team')}
            content={t('unable_delete_team_note')}
          />
        )}
      </DialogContent>
      {!isDeletionError && (
        <DialogActions>
          <div className="btns-toolbar">
            <ThemeButton
              startIcon="delete"
              disabled={getTotalActiveHoldCards(data) > 0 && !termsAcceptWatch}
              onClick={() => {
                if (!isConfirm) {
                  setIsConfirm(true);
                } else {
                  handleSubmit(onSubmit)();
                }
              }}
              loading={isLoading}
            >
              {t('yes_delete')}
            </ThemeButton>
            <ThemeButton
              onClick={() => (!isConfirm ? close() : setIsConfirm(false))}
              appearance="secondary"
            >
              {t('no_cancel')}
            </ThemeButton>
          </div>
        </DialogActions>
      )}
    </>
  );
}
